import React from "react";
import PropTypes from "prop-types";

import Label from "ui/text/Label";

import TicketCard from "./TicketCard";

import { t } from "i18n/index";
import { getServiceFeeLabel } from "utils/profile/getServiceFeeLabel";

const TicketList = ({ tickets, products, showApplicationFee, onAction, requires_approval, cartMode, showThumb }) => {
  const serviceFeesLabel = getServiceFeeLabel(showApplicationFee);

  const ticketList = tickets || [];
  const productList = products || [];

  if (ticketList.length === 0 && productList.length === 0) return null;

  const showApplicationFeeLabel = [...ticketList, ...productList].find((item) => item.price > 0);

  // Only show section titles when both groups are present; a single group needs no heading.
  const showSectionTitles = ticketList.length > 0 && productList.length > 0;

  const renderCard = (item) => (
    <TicketCard key={item.id} ticket={item} onAction={onAction} requires_approval={requires_approval} cartMode={cartMode} showThumb={showThumb} />
  );

  return (
    <div className="tickets">
      {ticketList.length > 0 && (
        <>
          {showSectionTitles && <Label bold className={"tickets-section-title"}>{t("literal:tickets")}</Label>}
          {ticketList.map(renderCard)}
        </>
      )}
      {productList.length > 0 && (
        <>
          {showSectionTitles && <Label bold className={"tickets-section-title"}>{t("literal:merch")}</Label>}
          {productList.map(renderCard)}
        </>
      )}
      {showApplicationFeeLabel && (
        <Label padded secondary small className={"application-fee-disclaimer"}>
          {serviceFeesLabel}
        </Label>
      )}
    </div>
  );
};

TicketList.propTypes = {
  tickets: PropTypes.array,
  products: PropTypes.array,
  showApplicationFee: PropTypes.bool,
  onAction: PropTypes.func,
  requires_approval: PropTypes.bool,
  cartMode: PropTypes.bool,
  showThumb: PropTypes.bool
};

export default TicketList;
